import React from "react";
import { Button, Grid, ListItem, Tooltip, Typography } from "@material-ui/core";
import ChipInput from "../../../components/ChipInput/ChipInput";
import FormTextField from "../../../components/FormTextField/FormTextField";
import { CANNED_RESPONSE_TOOLTIPS } from "../../../utility/toolTipMessages";
import RichTextField from "../../../components/RichTextField/RichTextField";

const CHARACTER_LIMIT = 1024;

const getResponseNameErrorMessage = (value) => {
	if (!value) {
		return "Response name is required.";
	}

	if (value.length > 50) {
		return "Response name cannot exceed 50 characters.";
	}
};
/**
 * Details of responses from the category
 */
export const ResponseDetails = ({
	response,
	removeResponseHandler,
	setResponse,
	setFormEdited,
	formEdited,
	responseAutofocus,
}) => {
	const updatePropertyHandler = React.useCallback(
		(property, value) => setResponse({ ...response, [property]: value }),
		[response, setResponse],
	);

	return (
		<ListItem>
			<Grid item xs={12}>
				<div style={{ display: "grid" }}>
					<FormTextField
						autoFocus={responseAutofocus}
						label="Name"
						formEdited={formEdited}
						required
						errorMessage={getResponseNameErrorMessage(response.responseName)}
						startingValue={response.responseName}
						setEdited={setFormEdited}
						setConfigValue={updatePropertyHandler}
						valueName={"responseName"}
						styleObject={{ minWidth: 120 }}
						enableDebounce
						errorCheck={(val) => !val || val.length > 50}
						toolTipMessage={CANNED_RESPONSE_TOOLTIPS.RESPONSE_NAME}
					/>
					<div className="d-flex mb-4 position-relative" style={{ marginTop: 10 }}>
						<div style={{ position: "absolute", bottom: "5px", zIndex: 1 }}>
							<Typography style={{ fontSize: 12, color: "gray", fontWeight: "lighter", marginBottom: 5 }}>
								Tags
							</Typography>
							<Tooltip arrow interactive placement={"bottom-start"} title={CANNED_RESPONSE_TOOLTIPS.TAGS}>
								<i style={{ height: "15px", color: "gray" }} className="fas fa-info-circle" />
							</Tooltip>
						</div>
						<ChipInput
							blurBehavior="add-or-clear"
							defaultValue={response.tags}
							style={{ marginTop: "15px", minWidth: 120, flex: 1, paddingLeft: "25px" }}
							onChange={(chip) => {
								updatePropertyHandler("tags", chip);
								setFormEdited(true);
							}}
						></ChipInput>
					</div>
				</div>
				<div style={{ display: "grid", marginBottom: 15 }}>
					<RichTextField
						height={280}
						value={response.message}
						onChange={(val) => {
							updatePropertyHandler("message", val);
							setFormEdited(true);
						}}
						placeholder="Message"
						characterLimit={CHARACTER_LIMIT}
						error={!response.message}
						extensions={{
							bold: true,
							italic: true,
							bulletList: true,
							orderedList: true,
							history: true,
						}}
						overrideExtensions
					/>
				</div>
				<Button
					variant="outlined"
					size="small"
					style={{
						opacity: 1,
						color: "#cc1f20",
						borderColor: "#cc1f20",
						width: 72,
						marginLeft: "auto",
						display: "flex",
					}}
					onClick={removeResponseHandler}
				>
					Remove
				</Button>
			</Grid>
		</ListItem>
	);
};
